
export default function Footer() {
  return (
    <footer className="bg-[#2D4191] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/d6212764e2e22a594116bb5aaa2c701d/47a096264119cb62209e551a4bc73f5a.png" 
                alt="Baufaktura Logo" 
                className="h-8 w-auto"
              />
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              Seit 35 Jahren die bewährte kaufmännische Software für Handwerker in Deutschland. 
              Über 15.000 zufriedene Kunden vertrauen auf unsere Lösungen.
            </p>
            <div className="text-sm text-gray-400">
              <p className="font-semibold text-white mb-2">Huonker Softwaretechnik</p>
              <p>Ihr Partner für professionelle Handwerker-Software</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Schnellzugriff</h3>
            <ul className="space-y-2">
              <li>
                <a href="#funktionen" className="text-gray-300 hover:text-[#EDEFF9] transition-colors cursor-pointer">
                  Funktionen
                </a>
              </li>
              <li>
                <a href="#vorteile" className="text-gray-300 hover:text-[#EDEFF9] transition-colors cursor-pointer">
                  Vorteile
                </a>
              </li>
              <li>
                <a href="#preise" className="text-gray-300 hover:text-[#EDEFF9] transition-colors cursor-pointer">
                  Preise
                </a>
              </li>
              <li>
                <a href="https://help.baufaktura.de" className="text-gray-300 hover:text-[#EDEFF9] transition-colors cursor-pointer">
                  Hilfe & Support
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Kontakt</h3>
            <ul className="space-y-2 text-gray-300">
              <li className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                <span>+49 (0) 123 456 789</span>
              </li>
              <li className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                <span>info@baufaktura.de</span>
              </li>
              <li className="flex items-center">
                <i className="ri-time-line mr-2"></i>
                <span>Mo-Fr: 8:00-17:00 Uhr</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#4A5BAE] mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-sm">
            © 2024 Huonker Softwaretechnik. Alle Rechte vorbehalten.
          </div>
          <div className="flex items-center space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-gray-400 hover:text-[#EDEFF9] text-sm cursor-pointer">
              Datenschutz
            </a>
            <a href="#" className="text-gray-400 hover:text-[#EDEFF9] text-sm cursor-pointer">
              Impressum
            </a>
            <a href="#" className="text-gray-400 hover:text-[#EDEFF9] text-sm cursor-pointer">
              AGB
            </a>
            <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-[#EDEFF9] text-sm cursor-pointer">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
